"use client";

import { useRouter } from "@/i18n/navigation";
import { CustomButton } from "@/components/ui/custom-button";
import { FolderIcon } from "@/components/icons/folder";

export const MyFiles = () => {
	const router = useRouter();

	return (
		<CustomButton
			type="button"
			variant="primary"
			size="sm"
			className="whitespace-nowrap"
			onClick={() => router.push("/app")}
		>
			<FolderIcon className="mr-2 size-4" />
			<span>My Stash</span>
		</CustomButton>
	);
};
